<div fxLayout="column" *ngIf="!isRequestLoading">
    <!--<div fxLayout="column">-->
    <!--  <div fxLayout="row" class="pageTitle">-->
    <!--    Δημοσίευση δήλωσης-->
    <!--  </div>-->
    <!--</div>-->

    <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center" style="height: 50px; margin-bottom: 20px;">
        <span class="pageTitle" fxFlex="95">Δημοσίευση δήλωσης</span>
        <span><mat-icon (click)="close()">close</mat-icon></span>
    </div>

    <mat-horizontal-stepper #stepper [linear]="isLinear" style="margin-top:10px;">
        <mat-step>
            <ng-template matStepLabel>Επιλογή δήλωσης</ng-template>
            <app-loading *ngIf="formsLoading"></app-loading>
            <mat-tab-group *ngIf="!formsLoading">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Δηλώσεις συναίνεσης
                        </div>
                    </ng-template>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutAlign="start" class="formsTableContainer mat-elevation-z0">

                            <div fxLayout="row">
                                <mat-form-field appearance="legacy">
                                    <label>
                                        <input matInput (keyup)="searchConsents($event.target.value)"
                                               placeholder="Αναζήτηση τίτλου"/>
                                    </label>
                                </mat-form-field>
                            </div>

                            <table mat-table [dataSource]="consents" style="width: 100%;">
                                <mat-card *ngIf="formsLoading"
                                          style="display: flex; justify-content: center; align-items: center">
                                    <mat-progress-bar
                                            color="primary"
                                            mode="indeterminate">
                                    </mat-progress-bar>
                                </mat-card>

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="10"
                                        fxLayoutAlign="start center center">
                                        &nbsp;
                                    </th>
                                    <td mat-cell *matCellDef="let row" fxFlex="10" fxLayoutAlign="start center center">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                                      (change)="$event ? selection.toggle(row) : null"
                                                      [checked]="selection.isSelected(row)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef>ID</th>
                                    <td mat-cell *matCellDef="let student"> {{student.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="title">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="45"
                                        fxLayoutAlign="start center center"> Τίτλος
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="45"
                                        fxLayoutAlign="start center center"> {{student.title}} </td>
                                </ng-container>

                                <ng-container matColumnDef="date_created">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="25"
                                        fxLayoutAlign="start center center"> Ημ/Δημηιουργίας
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="25"
                                        fxLayoutAlign="start center center"> {{student.created_at}} </td>
                                </ng-container>

                                <ng-container matColumnDef="created_by">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="20"
                                        fxLayoutAlign="start center center"> Δημιουργήθηκε
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="20"
                                        fxLayoutAlign="start center center"> {{student.created_by_first_name}} {{student.created_by_last_name}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                                <tr mat-row *matRowDef="let record; columns: displayColumns"></tr>
                            </table>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Δηλώσεις εγγραφής
                        </div>
                    </ng-template>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutAlign="start" class="formsTableContainer mat-elevation-z0">
                            <div fxLayout="row">
                                <mat-form-field appearance="legacy">
                                    <label>
                                        <input matInput (keyup)="searchAffirmations($event.target.value)"
                                               placeholder="Αναζήτηση τίτλου"/>
                                    </label>
                                </mat-form-field>
                            </div>
                            <table mat-table [dataSource]="affirmations">
                                <mat-card *ngIf="formsLoading"
                                          style="display: flex; justify-content: center; align-items: center">
                                    <mat-progress-bar
                                            color="primary"
                                            mode="indeterminate">
                                    </mat-progress-bar>
                                </mat-card>

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="10"
                                        fxLayoutAlign="start center center">
                                        <!--                    <mat-checkbox (change)="$event ? masterToggle() : null"-->
                                        <!--                                  [checked]="selection.hasValue() && isAllSelected()"-->
                                        <!--                                  [indeterminate]="selection.hasValue() && !isAllSelected()">-->
                                        <!--                    </mat-checkbox>-->
                                    </th>
                                    <td mat-cell *matCellDef="let row" fxFlex="10" fxLayoutAlign="start center center">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                                      (change)="$event ? selection.toggle(row) : null"
                                                      [checked]="selection.isSelected(row)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef>ID</th>
                                    <td mat-cell *matCellDef="let student"> {{student.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="title">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="45"
                                        fxLayoutAlign="start center center"> Τίτλος
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="45"
                                        fxLayoutAlign="start center center"> {{student.title}} </td>
                                </ng-container>

                                <ng-container matColumnDef="date_created">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="25"
                                        fxLayoutAlign="start center center"> Ημ/Δημηιουργίας
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="25"
                                        fxLayoutAlign="start center center"> {{student.created_at}} </td>
                                </ng-container>

                                <ng-container matColumnDef="created_by">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="20"
                                        fxLayoutAlign="start center center"> Δημιούργηθηκε
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="20"
                                        fxLayoutAlign="start center center"> {{student.created_by_first_name}} {{student.created_by_last_name}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                                <tr mat-row *matRowDef="let record; columns: displayColumns"></tr>
                            </table>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                            Ανακοινώσεις
                        </div>
                    </ng-template>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutAlign="start" class="formsTableContainer mat-elevation-z0">
                            <div fxLayout="row">
                                <mat-form-field appearance="legacy">
                                    <label>
                                        <input matInput (keyup)="searchAnnouncements($event.target.value)"
                                               placeholder="Αναζήτηση τίτλου"/>
                                    </label>
                                </mat-form-field>
                            </div>
                            <table mat-table [dataSource]="announcements">
                                <mat-card *ngIf="formsLoading"
                                          style="display: flex; justify-content: center; align-items: center">
                                    <mat-progress-bar
                                            color="primary"
                                            mode="indeterminate">
                                    </mat-progress-bar>
                                </mat-card>

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="10"
                                        fxLayoutAlign="start center center">
                                    </th>
                                    <td mat-cell *matCellDef="let row" fxFlex="10" fxLayoutAlign="start center center">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                                      (change)="$event ? selection.toggle(row) : null"
                                                      [checked]="selection.isSelected(row)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef>ID</th>
                                    <td mat-cell *matCellDef="let student"> {{student.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="title">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="45"
                                        fxLayoutAlign="start center center"> Τίτλος
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="45"
                                        fxLayoutAlign="start center center"> {{student.title}} </td>
                                </ng-container>

                                <ng-container matColumnDef="date_created">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="25"
                                        fxLayoutAlign="start center center"> Ημ/Δημηιουργίας
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="25"
                                        fxLayoutAlign="start center center"> {{student.date_created}} </td>
                                </ng-container>

                                <ng-container matColumnDef="created_by">
                                    <th mat-header-cell *matHeaderCellDef fxFlex="20"
                                        fxLayoutAlign="start center center"> Δημιούργηθηκε
                                    </th>
                                    <td mat-cell *matCellDef="let student" fxFlex="20"
                                        fxLayoutAlign="start center center"> {{student.createdByFirstName}} {{student.createdByLastName}} </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                                <tr mat-row *matRowDef="let record; columns: displayColumns"></tr>
                            </table>

                        </div>
                    </div>
                </mat-tab>

            </mat-tab-group>

        </mat-step>


        <mat-step>
            <ng-template matStepLabel>Μήνυμα ειδοποίησης</ng-template>

            <div fxLayout="column" fxFlex="grow">

                <!-- Subject-->
                <div fxLayout="row" fxFlex="50">

                    <mat-form-field appearance="outline" fxFlex="grow">
                        <mat-label>Θέμα</mat-label>
                        <input matInput [(ngModel)]="subject" placeholder="Θέμα">
                    </mat-form-field>

                </div>
                <!---->
                <!-- Sender-->
                <div fxLayout="row" fxLayoutGap.gt-lg="10px" fxLayoutGap.lt-lg="5px" fxFlex="50">

                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>Διεύθυνση αποστολέα</mat-label>
                        <mat-select [(ngModel)]="selectedSender">
                            <mat-option *ngFor="let sender of senders" [value]="sender">{{sender.address}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>Όνομα αποστολέα</mat-label>
                        <mat-select [(ngModel)]="selectedSender">
                            <mat-option *ngFor="let sender of senders" [value]="sender">{{sender.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>Περιγραφή αποστολέα</mat-label>
                        <mat-select [(ngModel)]="selectedSender">
                            <mat-option *ngFor="let sender of senders"
                                        [value]="sender">{{sender.description}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>

                <!---->
                <!-- Editor-->
                <div fxLayout="row" fxFlex="grow" style="height: 650px; width: 100%;" *ngIf="stepper.selectedIndex === 1">
                    <app-text-editor (editorOutputContent)="updateMessage($event)" [isForUsers]="true"></app-text-editor>
<!--                    <quill-editor fxFlex="grow" [styles]="editorStyle" [(ngModel)]="message"></quill-editor>-->
                </div>
                <!---->
            </div>


        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Ολοκλήρωση</ng-template>
            <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:40px;">
                <div fxLayout="row">
                    <img src="assets/images/complete-icon.png" alt="complete" style="width:50px; height:50px;"/>
                </div>
                <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif; margin-top:20px;">Η ενέργειά σας
                    ολοκληρώθηκε με επιτυχία
                </div>
            </div>
            <mat-card *ngIf="isNotificationLoading" style="display: flex; justify-content: center; align-items: center"
                      class="mat-elevation-z0">
                <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
            </mat-card>
        </mat-step>
    </mat-horizontal-stepper>


    <mat-dialog-actions style="margin-bottom: 20px;">
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="10px">

            <div *ngIf="stepper.selectedIndex === 0">
                <button mat-flat-button color="primary" [disabled]="proceedStep() || isRequestLoading "
                        [class.spinner]="isRequestLoading" (click)="next()">Επομένο
                </button>
            </div>

            <div *ngIf="stepper.selectedIndex === 1">
                <button mat-flat-button color="primary" (click)="previous()">Προηγούμενο</button>
                <button mat-flat-button color="primary" [class.spinner]="isRequestLoading"
                        [disabled]="validMessage() || isRequestLoading" (click)="next()">Επομένο
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>

<div *ngIf="isRequestLoading">
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" style="height: 50px;">
        <div fxFlex>Δημοσίευση</div>
        <div style="height: 25px;"><img src="assets/images/loading.gif" alt="loading" width="25" height="25"/></div>
    </div>
</div>


